
var id = "复核";
var markup = "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"复核\"><defs><style type=\"text/css\"></style></defs><path d=\"M32.128 479.36c0-135.616-0.128-186.496-0.128-322.144C32 39.648 97.28 32 160 32h512.096c98.624 0 129.152 33.568 129.152 128v64c0 50.464-64.256 44.672-64.256 0v-64c0-47.392-15.392-64-64.896-64H160c-52.992 0-64 7.2-64 64v640c0 35.104 19.2 64.032 64 64.032h128c39.168 0 42.016 64 0 64s-73.824 0.512-152.128 0.192c-46.208-0.192-84.448-27.52-98.08-69.888a124.288 124.288 0 0 1-5.44-37.504C32 685.728 32.128 614.56 32.128 479.36M671.488 992c177.056 0.032 320.32-142.56 320.512-318.976 0.192-177.088-142.624-320.544-319.488-320.768-176.864-0.256-320.448 143.04-320.448 319.808-0.032 176.8 142.88 319.904 319.424 319.936m0.896-575.68c141.6 0.352 255.776 115.52 255.392 257.568-0.32 140-115.936 254.144-256.96 253.792-140.48-0.416-254.72-115.552-254.432-256.416 0.288-140.416 115.648-255.264 256-254.944m-64.256-192.768H224.032c-46.016 0-48 64.864 0 64.864h384.096c44 0.032 51.008-64.832 0-64.864zM288.032 415.584h-64c-46.016 0-48 64.832 0 64.832h64c44 0.032 51.008-64.832 0-64.832zM828.928 552.8a37.088 37.088 0 0 1 0 52.416L648.576 785.568a37.44 37.44 0 0 1-3.136 2.784 36.864 36.864 0 0 1-55.2 3.104l-75.136-75.104a37.12 37.12 0 0 1 52.48-52.448l48.864 48.864L776.48 552.8a37.056 37.056 0 0 1 52.448 0z\" fill=\"#fff\" p-id=\"615\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
